import { usePublicConfig } from '@/features/settings/hooks/useServicesSettings';

import { useConsentScript } from '../hooks/useConsentScript';
import { CookieCategory } from '../types';

/**
 * Tag Google Ads (gtag.js, ID AW-…), vincolato al consenso di PROFILAZIONE.
 *
 * Come GA4: nessuno snippet in index.html (caricherebbe il tag prima della
 * scelta dell'utente) — lo script viene iniettato/rimosso a runtime.
 * L'ID arriva da GET /settings/public-config (configurabile da admin,
 * /dashboard/admin/tracking); null = feature spenta, non si monta nulla.
 *
 * dataLayer/gtag sono gli stessi globals di GoogleAnalytics.tsx: se GA è già
 * inizializzato riusiamo la sua coda, altrimenti la creiamo qui.
 */
function AdsTagLoader({ tagId }: { tagId: string }) {
  useConsentScript(CookieCategory.PROFILING, {
    id: 'google-ads-gtag',
    src: `https://www.googletagmanager.com/gtag/js?id=${tagId}`,
    onLoad: () => {
      (window as unknown as Record<string, boolean>)[`ga-disable-${tagId}`] = false;
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        window.gtag = function gtag(...args: unknown[]) {
          window.dataLayer.push(args);
        };
        window.gtag('js', new Date());
      }
      window.gtag('config', tagId);
    },
    onRevoke: () => {
      (window as unknown as Record<string, boolean>)[`ga-disable-${tagId}`] = true;
    },
  });

  return null;
}

export function GoogleAdsTag() {
  const { data } = usePublicConfig();
  const tagId = data?.googleAdsTagId;

  if (!tagId) return null;
  return <AdsTagLoader tagId={tagId} />;
}
